export default "__VITE_ASSET__BOLcvsoD__"